import HeaderTitle from './content-header/HeaderTitle'
import Loader from '../Loader'

export default {
  mixins: [
    HeaderTitle,
    Loader
  ]
}
